import ProjectSliderModal from './project-slider-modal';
export default ProjectSliderModal;